import cn from 'classnames';
import React__default from 'react';
import { Sheet, Dialog } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import { normalizeTab, hasItem } from '@sravni/ugc/lib/specialOffers/helpers';
import { COMMON_OFFERS_LIST, EDUCATION_OFFERS_LIST } from '@sravni/ugc/lib/specialOffers/lists';
import { getTabTitle } from '../../../innerComponents/UltimateSpecialOffers/src/helpers/getTitle.js';
import { AuthorizationLink } from '../../IdleSpecialOffersPopup/src/components/AuthorizationLink.js';
import modules_17a50390 from './PopupForSpecialOffers.module.scss.js';

const PopupForSpecialOffersWithAuthorization = ({ children, onClose, wasShown, canBeVisible, isContentLoaded, activeTab: propsActiveTab, pushEvent, }) => {
    const isMobile = useIsMobile();
    const activeTab = propsActiveTab && normalizeTab(propsActiveTab);
    const isVisible = !wasShown && canBeVisible;
    const contentLoadedStyles = {
        [modules_17a50390.contentLoaded]: isContentLoaded,
    };
    const authorizationLinkStyles = {
        ...(activeTab && {
            [modules_17a50390['authorizationLink--withAllOffersLink']]: hasItem([...COMMON_OFFERS_LIST, ...EDUCATION_OFFERS_LIST], activeTab),
        }),
    };
    const handleClickAuthorizationLink = () => activeTab &&
        pushEvent({
            event: 'mainEvent',
            eventCategory: getTabTitle(activeTab),
            eventAction: 'Войдите|Попап',
            eventLabel: undefined,
            eventValue: undefined,
        });
    return isMobile ? (React__default.createElement(Sheet, { visible: isVisible, onClose: onClose, closable: true, className: cn(modules_17a50390.sheet, modules_17a50390.background) },
        React__default.createElement(Sheet.Content, { className: cn(modules_17a50390.sheet__content, contentLoadedStyles) },
            children,
            React__default.createElement(AuthorizationLink, { className: cn(modules_17a50390.sheet__authorizationLink, authorizationLinkStyles), onClick: handleClickAuthorizationLink })))) : (React__default.createElement(Dialog, { visible: isVisible, onClose: onClose, className: cn(modules_17a50390.dialog, modules_17a50390.background) },
        React__default.createElement(Dialog.Content, { className: cn(modules_17a50390.dialog__content, contentLoadedStyles) },
            children,
            React__default.createElement(AuthorizationLink, { className: cn(modules_17a50390.dialog__authorizationLink, authorizationLinkStyles), onClick: handleClickAuthorizationLink }))));
};

export { PopupForSpecialOffersWithAuthorization };
//# sourceMappingURL=PopupForSpecialOffersWithAuthorization.js.map
